import type { SVGProps } from 'react';

const Clock = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 19.25C16.0041 19.25 19.25 16.0041 19.25 12C19.25 7.99594 16.0041 4.75 12 4.75C7.99594 4.75 4.75 7.99594 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M12 8V12L14 14" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export default Clock;
